/**
 * Builds the redirect URL for the Mercado Pago checkout of a `preferenceId`
 * the FRENET account created (`POST /internal/providers/frenet/deposit`,
 * TTP-270) — Trivio never intermediates the payment itself (CLAUDE.md domain
 * rule #1), this module only points the browser at Frenet's own Mercado
 * Pago checkout; the checkout itself runs entirely against Frenet's own
 * integration, and Frenet's own `CallbackUrls` (`frenet-deposit.service.ts`)
 * bring the browser back to `/providers?deposit=success|failure|pending`
 * (`ProvidersPage.tsx`).
 *
 * REVERTED (2026-09-04) from the Wallet Brick
 * (`mp.bricks().create('wallet', ...)`) this file used briefly — real
 * production testing hit a hard `401 get_preference_details_failed` from
 * `GET https://api.mercadopago.com/bricks/preferences/{id}`. That call —
 * which the Wallet Brick makes before it can render — DOES require the
 * `public_key` to belong to (or have access to) the same Mercado Pago
 * account that created the preference. The earlier guidance this file's
 * previous version was based on ("PUBLIC_KEY doesn't need to belong to the
 * account that created the preference") holds for Checkout Pro in general,
 * but not for this specific Bricks endpoint — confirmed wrong the hard way,
 * so trust THIS comment over any docstring making that claim. Since Trivio
 * has no access to Frenet's own Mercado Pago credentials (BYO-credentials,
 * CLAUDE.md domain rule #2), the Wallet Brick can never work for a
 * preference Frenet created — this isn't a config problem, it's structural.
 * The classic redirect needs no public key at all — it already worked in
 * the founder's own real end-to-end test the same day (real card, real
 * `depositReference` returned) — so it's the correct integration here, not
 * a "fallback". `VITE_MP_PUBLIC_KEY` is gone — nothing in this flow needs it
 * anymore.
 */
export function getMercadoPagoCheckoutRedirectUrl(preferenceId: string): string {
  return `https://www.mercadopago.com.br/checkout/v1/redirect?pref_id=${encodeURIComponent(preferenceId)}`;
}
